var _defs, _path, _path2, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 106.1 103.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #ffc557;\n        stroke-miterlimit: 10;\n        stroke-width: 7.49px;\n      }\n\n      .cls-2 {\n        fill: #ffc557;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.39,0h53.32C82.77,0,85.26,2.49,85.26,5.55v25.78c0,17.78-14.43,32.21-32.21,32.21h0c-17.78,0-32.21-14.43-32.21-32.21V5.55C20.84,2.49,23.32,0,26.39,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.72,90.02h14.65c6.43,0,11.65,5.22,11.65,11.65h0c0,.88-.71,1.59-1.59,1.59h-34.77c-.88,0-1.59-.71-1.59-1.59h0c0-6.43,5.22-11.65,11.65-11.65Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 46.28,
    y: 51.19,
    width: 13.53,
    height: 41.48
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.5,9.13h9.71c7.24,0,10.87,7.95,5.75,12.59l-21.95,19.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.6,9.13h-9.71c-7.24,0-10.87,7.95-5.75,12.59l21.95,19.92"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyIcon);
export default __webpack_public_path__ + "static/media/trophy_icon.710bf0d28fc28b1de1d13d1ee4001bb2.svg";
export { ForwardRef as ReactComponent };